import { render } from "./addbranch.vue?vue&type=template&id=feec5a5a"
import script from "./addbranch.vue?vue&type=script&lang=js"
export * from "./addbranch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__